import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import PeopleIcon from '@mui/icons-material/People';
export function SocialProof() {
  return <section className="bg-brand-800 text-white py-4 px-4" data-id="element-254">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 text-center" data-id="element-255">
        <div className="flex flex-col items-center gap-2" data-id="element-256">
          <div className="flex items-center gap-2 text-yellow-400" data-id="element-257">
            {[...Array(5)].map((_, i) => <StarIcon key={i} fontSize="small" data-id="element-258" />)}
          </div>
          <p className="font-bold text-lg" data-id="element-259">4.9/5 calificación promedio</p>
        </div>

        <div className="hidden md:block w-px h-12 bg-brand-600" data-id="element-260"></div>

        <div className="flex flex-col items-center gap-2" data-id="element-261">
          <PeopleIcon className="text-brand-300" fontSize="large" data-id="element-262" />
          <p className="font-bold text-lg" data-id="element-263">+500 PERSONAS YA EMPEZARON</p>
          <p className="text-brand-200 text-sm" data-id="element-264">A crear ingresos desde casa</p>
        </div>

        <div className="hidden md:block w-px h-12 bg-brand-600" data-id="element-265"></div>

        <div className="flex flex-col items-center gap-2" data-id="element-266">
          <div className="flex gap-4" data-id="element-267">
            <div className="flex items-center gap-1" data-id="element-268">
              <MenuBookIcon className="text-brand-300" data-id="element-269" />
              <span className="font-bold" data-id="element-270">2 tomos completos</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-271">
              <CardGiftcardIcon className="text-brand-300" data-id="element-272" />
              <span className="font-bold" data-id="element-273">4 bonos incluidos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}